<div class="position-relative d-none d-sm-block">
  <!-- go to list view -->
  <!-- <button routerLink="/list-view" class="goto-btn text-16-500-125 text-c3">
      <img width="18" height="18" src="assets/icons/play_btn_red.svg" alt="">
      {{'Go to list view' | translate}}
    </button> -->

  <!-- MAP VIEW with video carousel -->
  <div #MapVideoDiv *ngIf="agmView">

    <agm-map #AgmMap [latitude]="lat" [longitude]="lng" [zoom]="zoom" [styles]=style [minZoom]="2" [maxZoom]="4"
      [streetViewControl]="false" (mapReady)="videoMapReady($event)">
      <!-- [label]="{color: 'white', text: country.country_videos.length.toString()}"
        [iconUrl]="country.flag || 'assets/images/india-marker.svg'"
        (mouseOver)="clickedMarker(country, country,iw)"
        -->
      <agm-overlay *ngFor="let country of countywiseData; let i = index" (markerClick)="markerCliked(country)"
        [latitude]="country.latitude" [longitude]="country.longitude">
        <div class="position-relative cursor-pointer">
          <img *ngIf="country?.flag == null" src="assets/images/world.svg" height="36" width="36">
          <img *ngIf="country?.flag != null" [src]="country?.flag" height="36" width="36">
          <div class="country-badge">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              {{country.country_videos.length}}
            </div>
          </div>
        </div>

        <agm-info-window #iw [isOpen]="isInfoWindowOpen(country.id)" (showCloseButton)="false">
          <div class="mx-0 info-width">
            <div class="d-flex align-items-center">
              <div class="d-flex gap-3 align-items-center pr-4">
                <img height="24" width="24" [src]="country.flag" alt="">
                <span class="text-20-500-120 text-c6">{{country.name}}</span>
              </div>
              <mat-icon class="ms-auto c-pointer" (click)="closeInfoWindow(countywiseData)"
                style="transform: scale(0.7);">
                <span class="material-icons-outlined">close</span>
              </mat-icon>
            </div>
            <!-- <div class="col-12 px-0 mt-3">
                <p *ngIf="country.country_videos.length != 0 ">
                  {{country.country_videos[0].current_slide+1}} of {{country.country_videos.length}} Videos
                </p>
                <p *ngIf="country.country_videos.length == 0 "> 0 Videos</p>
              </div>
              <div class="mulish-bold text-sm col-12 px-0 heading-slider" *ngIf="country.country_videos.length != 0 ">
                <p class="mb-0 info-heading text-break">
                  {{country.country_videos[country.country_videos[0].current_slide].description}}
                </p>
              </div> -->
            <div class="col-12 px-0 mt-4" *ngIf="country.country_videos.length != 0 ">
              <div id="maincarousel">
                <mat-carousel #carouselContainer [hideArrows]="true" [hideIndicators]="true" [autoplay]="false"
                  (change)="updateSlider($event,country.country_videos)" [slideHeight]="'100%'" class="movieslider">
                  <mat-carousel-slide #matCarouselSlide *ngFor="let slide of country.country_videos; let i = index"
                    [image]="slide.movieThumbnail" class="carousel-movie">
                    <div class="slider-content" (click)="movieClick(slide,iw)">
                      <img src="assets/icons/play-btn.svg" alt="">
                    </div>
                  </mat-carousel-slide>
                </mat-carousel>
              </div>
              <div class="mt-5 d-flex align-items-center justify-content-evenly">
                <img (click)="carouselContainer.previous()" class="c-pointer" src="assets/icons/previous.svg" alt="">
                <span
                  class="text-14-500-171 text-c4">{{country.country_videos[0].current_slide+1}}/{{country.country_videos.length}}</span>
                <img (click)="carouselContainer.next()" class="c-pointer" src="assets/icons/next.svg" alt="">
              </div>
            </div>
            <!-- controls -->
            <!-- <span>previouse</span><span (click)="carouselContainer.next">next</span> -->

            <div class="col-12 px-0 mt-3" *ngIf="country.country_videos.length == 0 ">
              <img src="assets/images/no-data-info.svg" alt="" class="w-100">
              <p class="mulish-normal text-xxs text-center">
                {{"Selected country doesn’t have any videos uploaded" | translate}}</p>
            </div>
            <!-- <div class="col-12 px-0" *ngIf="country.country_videos.length != 0 ">
                <p class="mulish-bold text-xxs mt-4">
                  <a class="text-danger pointer-cursor" (click)="showAllVideos(country,iw)">
                    {{"SEE ALL VIDEOS" | translate}}
                  </a>
                </p>
              </div> -->
          </div>
        </agm-info-window>

      </agm-overlay>
    </agm-map>
  </div>

  <!-- MAP VIEW with score marker -->
  <div #MapDiv *ngIf="!agmView" class="position-relative" style="height: calc(100vh - 80px);overflow: hidden;">
    <!-- <div #MapHeader class="row map-header position-absolute" *ngIf="isLoggedIn">
        <div class="col-12 px-0">
          <div class="d-flex justify-content-between">
            <div>
              <p class="mulish-bold text-14 mb-0">{{participantData?.name}}</p>
            </div>
            <div class="d-flex">
              <div class="score-chip d-flex align-items-center">
                <img class="user-badge" *ngIf="participantData?.info.badge == 'None'" src="assets/images/no-badge.svg"
                  alt="">
                <img class="user-badge" *ngIf="participantData?.info.badge == 'Bronze'"
                  src="assets/images/bronze-badge.svg" alt="">
                <img class="user-badge" *ngIf="participantData?.info.badge == 'Silver'"
                  src="assets/images/silver-badge.svg" alt="">
                <img class="user-badge" *ngIf="participantData?.info.badge == 'Gold'" src="assets/images/gold-badge.svg"
                  alt="">
                <p *ngIf="participantData?.info.badge == 'None'" class="mb-0 pl-2 text-xxs">
                  {{'No badge yet' | translate}}</p>
                <p *ngIf="participantData?.info.badge != 'None'" class="mb-0 pl-2 text-xxs">
                  {{participantData?.info.badge | translate}}</p>
              </div>
              <div class="score-chip mx-3 d-flex align-items-center">
                {{'Score :' | translate}} {{participantData?.info.score}} / {{participantData?.info.maximum_score}}
              </div>
              <div class="d-flex align-items-center">
                <p class="mulish-bold mb-0 text-xxs color-5F5F5F pointer-cursor" (click)="signOut()">
                  {{'Sign out' | translate | uppercase}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 mt-3">
          <div class="">
            <div class="d-flex align-items-center filter-progress">
              <div>
                <p class="mulish-normal text-14 mb-0">{{'SDG completed:' | translate}}
                  {{participantData?.info.completed_sdg_count}}
                  / {{participantData?.info.total_sdg_count}}</p>
              </div>
              <div class="d-flex align-items-center sdgBanner-wd">
                <div class="custom-progress ml-3 w-100">
                  <div class="progress">
                    <div class="progress-bar bg-primary" role="progressbar"
                      [style.width.%]="participantData?.info.sdg_completion_percentage" aria-valuenow="12"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
              <div (click)="openSdg()" class="sdg-badge-info">
                <img height="16" src="assets/images/redTrophy.svg" alt="">
                <span class="ml-2">
                  {{'View sdg badges' | translate | uppercase}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 mt-3 position-relative">
          <div class="scrolling-wrapper row flex-row flex-nowrap mx-0" #mapbanner>
            <div class="position-absolute right-align leave-card-icon d-md-flex align-items-center d-none h-100">
              <img src="assets/images/right-arrow.svg" alt="" (click)="nextClick()" class="pointer-cursor">
            </div>
            <div
              class="position-absolute left-align pull-left leave-card-icon d-md-flex align-items-center d-none h-100">
              <img src="assets/images/left-arrow.svg" alt="" (click)="previousClick()" class="pointer-cursor">
            </div>
            <div class="map-banner-card pointer-cursor" id="{{item.id}}"
              *ngFor="let item of lstAllSDGBanner;let i =index;">
              <div class="d-flex align-items-center w-100" (click)="bannerClicked(item,i,$event)" data-toggle="tooltip"
                title="{{item.name}}">
                <div class="position-relative">
                  <img *ngIf="item.info.badge == 'Gold'" src="assets/images/gold-badge.svg" alt="" width="13"
                    height="13" class="position-absolute" style="right: -10%;top: -5%;">
                  <img *ngIf="item.info.badge == 'Silver'" src="assets/images/silver-badge.svg" alt="" width="13"
                    height="13" class="position-absolute" style="right: -10%;top: -5%;">
                  <img *ngIf="item.info.badge == 'Bronze'" src="assets/images/bronze-badge.svg" alt="" width="13"
                    height="13" class="position-absolute" style="right: -10%;top: -5%;">
                  <img *ngIf="item.info.badge == 'None'" src="assets/images/no-badge.svg" alt="" width="13" height="13"
                    class="position-absolute" style="right: -10%;top: -5%;">
                  <img *ngIf="item.image == null" src="assets/images/no-poverty.png" alt="" width="28" height="28"
                    class="img-circle">
                  <img *ngIf="item.image != null" [src]="item?.image" alt="" width="28" height="28" class="img-circle">
                </div>
                <p class="ml-3 mb-0 mulish-normal text-xxs ">{{item.name}}</p>
              </div>
              <div id="info{{item.id}}" class="row mx-0 sdg-info info-width-badge container font-normal"
                *ngIf="item.bannerClicked">
                <div class="position-absolute info-close-button pointer-cursor "><img
                    src="assets/images/close-movie.svg" alt="" class="info-window-close"
                    (click)="closeBannerInfo(item)"></div>
                <div class="col-12 px-0 border-btm d-flex flex-row align-items-center pb-4">
                  <div class="d-flex align-items-center pr-4">
                    <img *ngIf="item.image == null" src="assets/images/no-poverty.png" alt=""
                      class="sdg-icon-info-window">
                    <img *ngIf="item.image != null" [src]="item?.image" alt="" class="sdg-icon-info-window">
                  </div>
                  <p class="mulish-bold text-16 mb-0 line-height-120">{{item.name}}</p>
                </div>
                <div class="d-flex justify-content-center align-items-center my-4 font-normal">
                  <div class="text-center text-xxs text-default" *ngIf="item.info.badge == 'None'">
                    <img class="m-2 badge-img" src="assets/images/no-badge.svg" alt="">
                    <div>{{'No badge yet' | translate}}</div>
                  </div>
                  <div class="text-center text-xxs text-default" *ngIf="item.info.badge == 'Gold'">
                    <img class="m-2 badge-img" src="assets/images/gold-badge.svg" alt="">
                    <div>{{'Gold' | translate}}</div>
                  </div>
                  <div class="text-center text-xxs text-default" *ngIf="item.info.badge == 'Silver'">
                    <img class="m-2 badge-img" src="assets/images/silver-badge.svg" alt="">
                    <div>{{'Silver' | translate}}</div>
                  </div>
                  <div class="text-center text-xxs text-default" *ngIf="item.info.badge == 'Bronze'">
                    <img class="m-2 badge-img" src="assets/images/bronze-badge.svg" alt="">
                    <div>{{'Bronze' | translate}}</div>
                  </div>
                  <div class="ml-4 d-flex flex-column justify-content-between">
                    <div>
                      <div class="text-xxs mb-2 text-default">
                        {{'Total score in this SDG' | translate}}
                      </div>
                      <div class="score-chip mb-3">
                        <span class="text-xxs">
                          {{'Score :' | translate}} {{item.info.score}} / {{item.info.maximum_score}}
                        </span>
                      </div>
                    </div>
                    <div class="">
                      <div class="text-xxs mb-2 text-default">
                        {{'Questions completed :' | translate}} {{item.info.answered_questions}} /
                        {{item.info.total_questions}}
                      </div>
                      <div class="custom-progress">
                        <div class="progress">
                          <div class="progress-bar bg-primary" role="progressbar"
                            [style.width.%]="item.info.attempted_percentage" aria-valuenow="12" aria-valuemin="0"
                            aria-valuemax="100"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-xxs mulish-normal text-center text-default text-break"
                  *ngIf="item.info.badge != 'Gold' && item.info.answered_questions != item.info.total_questions">
                  {{'You’re pointNeed more points away to earn upComingBadge badge for this topic, continue playing' | translate: {pointNeed: item.pointNeed, upComingBadge: item.upComingBadge} }}
                </div>
                <div
                  class="bg-danger py-2 px-3 flex-center badge-custom cursor-pointer mulish-bold btn-light btn-block my-3 border-light-custom text-white"
                  (click)="viewSdgQuestions(item)">
                  <div *ngIf="item.info.answered_questions < item.info.total_questions">
                    {{'Start quiz' | translate | uppercase}} </div>
                  <div *ngIf="item.info.answered_questions == item.info.total_questions">
                    {{'View' | translate | uppercase}} </div>
                  <mat-icon class="ml-3">arrow_right_alt</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

    <!-- Category container sidebar -->
    <div class="cat-container">
      <div class="category-container" *ngIf="lstAllSDGBanner.length > 0">
        <p class="text-18-500-150 text-center">{{'Click a category to begin!' | translate}}</p>
        <div class="category-item-container">
          <div class="category-item mb-4" *ngFor="let item of lstAllSDGBanner;let i =index;">
            <div (click)="toggleCategoryItem(i)" class="mb-3 c-pointer d-flex gap-3 align-items-center">
              <img *ngIf="item.image != null" [src]="item?.image" alt="" width="28" height="28" class="img-circle">
              <p class="text-20-500-120 mb-0">{{(item.name.substring(item.name.indexOf(' ') + 1) | translate)}}</p>
              <div class="ms-auto category-badge">
                <img *ngIf="item.info.badge == 'Gold'" src="assets/icons/gold-badge.svg" alt="" width="28" height="28">
                <img *ngIf="item.info.badge == 'Silver'" src="assets/icons/silver-badge.svg" alt="" width="28"
                  height="28">
                <img *ngIf="item.info.badge == 'Bronze'" src="assets/icons/bronze-badge.svg" alt="" width="28"
                  height="28">
                <img *ngIf="item.info.badge == 'None'" src="assets/icons/no-badge.svg" alt="" width="28" height="28">
              </div>
            </div>
            <div [@expandCollapse]="activeIndex === i ? 'expanded' : 'collapsed'">
              <div class="border-top mb-3">
                <div class="mt-3 text-10-400-121 text-c1">
                  {{'Total score' | translate}}
                </div>
                <div class="mt-2">
                  <span class="score-chip text-18-500-150 mb-3">
                    {{item.info.score}} / {{item.info.maximum_score}}
                  </span>
                </div>
              </div>
            </div>
            <div class="text-12-400-133 text-c2 d-flex justify-content-between align-items-center">
              <span>{{'Questions completed :' | translate}} </span>
              <img *ngIf="item.info.answered_questions == item.info.total_questions && item.info.total_questions != 0 "
                src="assets/icons/finished.svg" alt="">
              <span
                *ngIf="item.info.answered_questions != item.info.total_questions">{{item.info.answered_questions}}/{{item.info.total_questions}}</span>
            </div>
            <div class="mt-3 custom-progress">
              <div class="progress">
                <div class="progress-bar bg-danger" role="progressbar" [style.width.%]="item.info.attempted_percentage"
                  aria-valuenow="12" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            <div class="w-100 mt-3 d-flex flex-row gap-2 align-items-center">
              <div *ngFor="let sdg of item.sdg">
                <img class="rounded cursor-pointer" (click)="showImage(sdg.image)" width="32" [src]="sdg.image"
                  alt="sdg_icon">
              </div>
            </div>
            <div [@expandCollapse]="activeIndex === i ? 'expanded' : 'collapsed'">
              <button appPreventDoubleClick [debounceTime]="1000"
                *ngIf="item.info.answered_questions != item.info.total_questions" (click)="viewSdgQuestions(item)"
                class="mt-3 quiz-btn text-16-500-125">
                {{ item.info.answered_questions > 0 ? ('Continue' | translate) : ('Start Quiz' | translate)}}
              </button>
              <button appPreventDoubleClick [debounceTime]="1000"
                *ngIf="item.info.answered_questions == item.info.total_questions" (click)="viewCategoryBadge(item)"
                class="mt-3 quiz-btn text-16-500-125">
                {{'View badge' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- AgmMap with score -->
    <agm-map #AgmMap2 *ngIf="lstExpeditionMap.length !=0" (mapReady)="expditionMapReady($event)" [latitude]="lat"
      [longitude]="lng" [zoom]="zoom" [styles]=style [minZoom]="2" [maxZoom]="4" [streetViewControl]="false">
      <agm-overlay (markerClick)="clickedMarker(country, country,iw)"
        *ngFor="let country of lstExpeditionMap; let i = index" [latitude]="country.latitude"
        [longitude]="country.longitude">
        <div class="position-relative cursor-pointer">
          <img *ngIf="country?.flag == null" src="assets/images/world.svg" height="46" width="46">
          <img *ngIf="country?.flag != null" [src]="country?.flag" height="46" width="46">
          <img *ngIf="country?.info?.badge == 'None'" src="assets/icons/no-badge.svg" alt="" width="23" height="23"
            class="position-absolute" style="right: -10%;top: -5%;">
          <img *ngIf="country?.info?.badge == 'Silver'" src="assets/icons/silver-badge.svg" alt="" width="23"
            height="23" class="position-absolute" style="right: -10%;top: -5%;">
          <img *ngIf="country?.info?.badge == 'Gold'" src="assets/icons/gold-badge.svg" alt="" width="23" height="23"
            class="position-absolute" style="right: -10%;top: -5%;">
          <img *ngIf="country?.info?.badge == 'Bronze'" src="assets/icons/bronze-badge.svg" alt="" width="23"
            height="23" class="position-absolute" style="right: -10%;top: -5%;">
        </div>
        <agm-info-window #iw [isOpen]="isInfoWindowOpen(country.id)" (showCloseButton)="false">
          <div class="row mx-0 info-width">
            <div class="px-0 d-flex justify-content-end">
              <img width="10" height="10" src="assets/icons/close.svg" alt=""
                (click)="closeInfoWindow2(lstExpeditionMap)">
            </div>
            <div class="col-12 px-0 mt-3 pb-3 d-flex align-items-center">
              <div class="d-flex align-items-center gap-3">
                <img width="24" height="24" [src]="country?.flag" alt="">
                <span class="text-20-500-120">{{country.name}}</span>
              </div>
              <span class="ms-auto">
                <img width="28" height="28" *ngIf="country.info.badge == 'None'" src="assets/icons/no-badge.svg" alt="">
                <img width="28" height="28" *ngIf="country.info.badge == 'Gold'" src="assets/icons/gold-badge.svg"
                  alt="">
                <img width="28" height="28" *ngIf="country.info.badge == 'Silver'" src="assets/icons/silver-badge.svg"
                  alt="">
                <img width="28" height="28" *ngIf="country.info.badge == 'Bronze'" src="assets/icons/bronze-badge.svg"
                  alt="">
              </span>
            </div>
            <div class="px-0">
              <div class="border-top mb-3">
                <div class="mt-3 text-10-400-121 text-c1">
                  {{'Total score' | translate}}
                </div>
                <div class="mt-2">
                  <span class="score-chip text-18-500-150 mb-3">
                    {{country.info.score}}/{{country.info.maximum_score}}
                  </span>
                </div>
              </div>
              <div class="text-12-400-133 text-c2 d-flex justify-content-between align-items-center">
                <span>{{'Questions completed' | translate}} </span>
                <img
                  *ngIf="country.info.answered_questions == country.info.total_questions && country.info.total_questions != 0"
                  src="assets/icons/finished.svg" alt="">
                <span
                  *ngIf="country.info.answered_questions != country.info.total_questions">{{country.info.answered_questions}}/{{country.info.total_questions}}</span>
              </div>
              <div class="mt-3 custom-progress">
                <div class="progress">
                  <div class="progress-bar bg-primary" role="progressbar"
                    [style.width.%]="country.info.attempted_percentage" aria-valuenow="50" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
            </div>
            <!-- expeditionMarkerCliked(country);closeInfoWindow2(lstExpeditionMap) -->
            <ng-container *ngIf="country.info.total_questions > 0">
              <button appPreventDoubleClick [debounceTime]="1000"
                *ngIf="country.info.answered_questions != country.info.total_questions"
                (click)="startQuizCounty(country?.id)" class="my-3 quiz-btn text-16-500-125">
                {{country.info.answered_questions > 0 ? ('Continue' | translate) : ('Start quiz' | translate )}}
              </button>

              <button appPreventDoubleClick [debounceTime]="1000"
                *ngIf="country.info.answered_questions == country.info.total_questions"
                (click)="viewCountryBadge(country)" class="my-3 quiz-btn text-16-500-125">
                {{ 'View badge' | translate }}
              </button>
            </ng-container>

          </div>
        </agm-info-window>
      </agm-overlay>
    </agm-map>
  </div>
</div>

<!-- for mobile screen sizes -->
<div class="mb-container d-block d-sm-none">
  <div class="d-flex justify-content-center">
    <h1 class="text-24-600-133 text-center w-75 ">{{'Select a category or country to begin!' | translate}}</h1>
  </div>
  <div class="w-100 mt-4 mb-5 filter-container text-16-500-150">
    <span (click)="selectedFilter = 'category'"
      [ngClass]="{'selected-filter': selectedFilter == 'category'}">{{'Category' | translate}}</span>
    <span (click)="selectedFilter = 'country'" [ngClass]="{'selected-filter': selectedFilter == 'country'}">{{'Country'
      | translate}}</span>
  </div>
  <!-- for category list -->
  <ng-container *ngIf="selectedFilter == 'category'">
    <div *ngFor="let item of lstAllSDGBanner;let i =index;" class="category-list mb-5">
      <div (click)="toggleCategoryItem(i)" class="mb-3 c-pointer d-flex gap-3 align-items-center">
        <img *ngIf="item.image != null" [src]="item?.image" alt="" width="28" height="28" class="img-circle">
        <p class="text-20-500-120 mb-0">{{(item.name.substring(item.name.indexOf(' ') + 1) | translate)}}</p>
        <div class="ms-auto category-badge">
          <img *ngIf="item.info.badge == 'Gold'" src="assets/icons/gold-badge.svg" alt="" width="28" height="28">
          <img *ngIf="item.info.badge == 'Silver'" src="assets/icons/silver-badge.svg" alt="" width="28" height="28">
          <img *ngIf="item.info.badge == 'Bronze'" src="assets/icons/bronze-badge.svg" alt="" width="28" height="28">
          <img *ngIf="item.info.badge == 'None'" src="assets/icons/no-badge.svg" alt="" width="28" height="28">
        </div>
      </div>
      <div>
        <div class="border-top mb-3">
          <div class="mt-3 text-10-400-121 text-c1">
            {{'Total score' | translate}}
          </div>
          <div class="mt-2">
            <span class="score-chip text-18-500-150 mb-3">
              {{item.info.score}} / {{item.info.maximum_score}}
            </span>
          </div>
        </div>
      </div>
      <div class="text-12-400-133 text-c2 d-flex justify-content-between align-items-center">
        <span>{{'Questions completed :' | translate}} </span>
        <img *ngIf="item.info.answered_questions == item.info.total_questions && item.info.total_questions != 0 "
          src="assets/icons/finished.svg" alt="">
        <span
          *ngIf="item.info.answered_questions != item.info.total_questions">{{item.info.answered_questions}}/{{item.info.total_questions}}</span>
      </div>
      <div class="mt-3 custom-progress">
        <div class="progress">
          <div class="progress-bar bg-danger" role="progressbar" [style.width.%]="item.info.attempted_percentage"
            aria-valuenow="12" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      <div class="w-100 mt-3 d-flex flex-row gap-2 align-items-center">
        <div *ngFor="let sdg of item.sdg">
          <img class="rounded cursor-pointer" (click)="showImage(sdg.image)" width="32" [src]="sdg.image"
            alt="sdg_icon">
        </div>
      </div>
      <div>
        <button appPreventDoubleClick [debounceTime]="3000"
          *ngIf="item.info.answered_questions != item.info.total_questions" (click)="viewSdgQuestions(item)"
          class="mt-3 quiz-btn text-16-500-125">
          {{ item.info.answered_questions > 0 ? ('Continue' | translate) : ('Start quiz' | translate)}}
        </button>
        <button appPreventDoubleClick [debounceTime]="1000"
          *ngIf="item.info.answered_questions == item.info.total_questions" (click)="viewCategoryBadge(item)"
          class="mt-3 quiz-btn text-16-500-125">
          {{'View badge' | translate}}
        </button>
      </div>
    </div>
  </ng-container>
  <!-- for country list -->
  <ng-container *ngIf="selectedFilter == 'country'">
    <div *ngFor="let country of lstExpeditionMap;let i =index;" class="category-list mb-5">
      <div (click)="toggleCategoryItem(i)" class="mb-3 c-pointer d-flex gap-3 align-items-center">
        <img *ngIf="country.flag != null" [src]="country.flag" alt="" width="28" height="28" class="img-circle">
        <p class="text-20-500-120 mb-0">{{country.name}}</p>
        <div class="ms-auto category-badge">
          <img *ngIf="country.info.badge == 'Gold'" src="assets/icons/gold-badge.svg" alt="" width="28" height="28">
          <img *ngIf="country.info.badge == 'Silver'" src="assets/icons/silver-badge.svg" alt="" width="28" height="28">
          <img *ngIf="country.info.badge == 'Bronze'" src="assets/icons/bronze-badge.svg" alt="" width="28" height="28">
          <img *ngIf="country.info.badge == 'None'" src="assets/icons/no-badge.svg" alt="" width="28" height="28">
        </div>
      </div>
      <div>
        <div class="border-top mb-3">
          <div class="mt-3 text-10-400-121 text-c1">
            {{'Total score in this SDG' | translate}}
          </div>
          <div class="mt-2">
            <span class="score-chip text-18-500-150 mb-3">
              {{country.info.score}} / {{country.info.maximum_score}}
            </span>
          </div>
        </div>
      </div>
      <div class="text-12-400-133 text-c2 d-flex justify-content-between align-items-center">
        <span>{{'Questions completed :' | translate}} </span>
        <img
          *ngIf="country.info.answered_questions == country.info.total_questions && country.info.total_questions != 0 "
          src="assets/icons/finished.svg" alt="">
        <span
          *ngIf="country.info.answered_questions != country.info.total_questions">{{country.info.answered_questions}}/{{country.info.total_questions}}</span>
      </div>
      <div class="mt-3 custom-progress">
        <div class="progress">
          <div class="progress-bar bg-danger" role="progressbar" [style.width.%]="country.info.attempted_percentage"
            aria-valuenow="12" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      <ng-container *ngIf="country.info.total_questions > 0">
        <button appPreventDoubleClick [debounceTime]="3000"
          *ngIf="country.info.answered_questions != country.info.total_questions" (click)="startQuizCounty(country?.id)"
          class="my-3 quiz-btn text-16-500-125">
          {{country.info.answered_questions > 0 ? ('Continue' | translate) : ('Start quiz' | translate )}}
        </button>

        <button appPreventDoubleClick [debounceTime]="3000"
          *ngIf="country.info.answered_questions == country.info.total_questions" (click)="viewCountryBadge(country)"
          class="my-3 quiz-btn text-16-500-125">
          {{ 'View badge' | translate }}
        </button>
      </ng-container>
    </div>
  </ng-container>
</div>